module.exports = __webpack_public_path__ + "img/icon_anonyma.1b5e726a.svg";